var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"loading":_vm.loading,"title":_vm.title,"back":_vm.backRoute}},[_c('data-box',{attrs:{"status":false}},[_c('offer-group-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }